import "bootstrap/dist/css/bootstrap.min.css";
import { InputProvider } from "./components/context/InputGlobal/InputContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./components/context/Auth/AuthContext";
import { AuthForm } from "./components/Auth/AuthForm";
import { PrivateRoute } from "./components/PrivateRoute";
import { ToastProvider } from "./components/context/ToastContext";
import OCRPage from "./pages/OCRPage";
import ClientPage from "./pages/ClientPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import UserPage from "./pages/UserPage";
import ConsultPage from "./pages/ConsultPage";
import ConsultCpfForm from "./components/Consult/ConsultCpfForm";
import HistoryPage from "./pages/HistoryPage";
import DashboardPage from "./pages/DashboardPage";
import JourneyUIConfig from "./pages/JourneyUIPage";
import JourneyPage from "./pages/JourneyPage";
import ConsultCpfPage from "./pages/ConsultCpfPage";
import CpfHistoryPage from "./pages/CpfHistoryPage";

function App() {
  const queryClient = new QueryClient();

  return (
    <ToastProvider>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<AuthForm />} />

            <Route path="/liveness/:token" element={<JourneyPage />} />

            <Route path="/consult" element={<Navigate to="/consult/cnpj" replace />} />

            {/* <Route
              path="/consult"
              element={
                <PrivateRoute>
                  <InputProvider>
                    <ConsultPage />
                  </InputProvider>
                </PrivateRoute>
              }
            /> */}

            <Route
              path="/consult/cnpj"
              element={
                <PrivateRoute>
                  <InputProvider>
                    <ConsultPage />
                  </InputProvider>
                </PrivateRoute>
              }
            />

            <Route
              path="/consult/cpf"
              element={
                <PrivateRoute>
                  <InputProvider>
                    <ConsultCpfPage />
                  </InputProvider>
                </PrivateRoute>
              }
            />

            <Route
              path="/ocr"
              element={
                <PrivateRoute>
                  <InputProvider>
                    <OCRPage />
                  </InputProvider>
                </PrivateRoute>
              }
            />
            <Route
              path="/client"
              element={
                <PrivateRoute>
                  <QueryClientProvider client={queryClient}>
                    <ClientPage />
                  </QueryClientProvider>
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <QueryClientProvider client={queryClient}>
                    <UserPage />
                  </QueryClientProvider>
                </PrivateRoute>
              }
            />

            <Route
              path="/history"
              element={
                <PrivateRoute>
                  <QueryClientProvider client={queryClient}>
                    <HistoryPage />
                  </QueryClientProvider>
                </PrivateRoute>
              }
            />

            <Route
              path="/history/cpf"
              element={
                <PrivateRoute>
                  <QueryClientProvider client={queryClient}>
                    <CpfHistoryPage />
                  </QueryClientProvider>
                </PrivateRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <QueryClientProvider client={queryClient}>
                    <DashboardPage />
                  </QueryClientProvider>
                </PrivateRoute>
              }
            />
            <Route
              path="/configuration-screen"
              element={
                <PrivateRoute>
                  <QueryClientProvider client={queryClient}>
                    <JourneyUIConfig />
                  </QueryClientProvider>
                </PrivateRoute>
              }
            />

            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ToastProvider>
  );
}

export default App;
